
import {useReducer} from 'react';
import {AgentState} from '@livekit/components-react';

type State = {
	agent: AgentState,
	show: 'preparing' | 'agent' | 'feedback' | 'thank-you',
	report: string,
	source: string,
	feedback?: Feedback,
};

export type Feedback = {
	thumbs?: 'up' | 'down',
	stars: {
		question: string,
		stars: number,
	}[],
};

type Action =
  | { type: 'AGENT', agent: AgentState }
  | { type: 'REPORT', report: string, source: string }
  | { type: 'FEEDBACK', feedback: Feedback, final: boolean }
;

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'REPORT':
		return {
			...state,
			show: 'agent',
			report: action.report,
			source: action.source,
		};

	case 'AGENT':
		if (state.agent !== action.agent &&
			action.agent === 'disconnected') {
			return {
				...state,
				agent: action.agent,
				show: 'feedback',
			};
		}

		return {
			...state,
			agent: action.agent,
		};

	case 'FEEDBACK':
		return {
			...state,
			show: action.final ? 'thank-you' : state.show,
			feedback: action.feedback,
		};
	}
};

export const useState = () => {
	const [state, dispatch] = useReducer(reducer, {
		agent: 'disconnected',
		show: 'preparing',
		report: '',
		source: '',
	});

	return {state, dispatch};
};
